
import AsNavFor from './banner/Banner'
import About from './about/About'
import Offers from './offers/Offers'
import Expertise from './expertise/Expertise'
import AppDownloadSection from './download/AppDownloadSection'
import Contact from './contact/Contact'

const Index = () => {
    return (
        <>
            <AsNavFor />
            <About />
            <Offers />
            <Expertise />
            <AppDownloadSection />
            <Contact />
        </>
    )
}

export default Index
